<template>
  <div class="ml18-ponto-eletronico-Monitoramento">
    <PageTitle
      icon="fa fa-calendar"
      main="Ponto eletrônico"
      sub="Monitoramentos ponto registrado"
    />
    <div class="ponto-eletronico3">
      <b-card no-body>
        <b-tabs>
          <b-tab title="Monitoramento ponto registrado" active
            ><PonMonitoramento
          /></b-tab>
          <b-tab title="Manutenção diária"><PonManutencaoDiaria /></b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import PonMonitoramento from "../ml18_frq_pontoeletronico/PontoEletronicoMonitoramento";
import PonManutencaoDiaria from "../ml18_frq_pontoeletronico/PontoManutencaoDiaria";

export default {
  name: "Ml18PontoEletronicoPrincipalMonitoramento",
  components: { PageTitle, PonMonitoramento, PonManutencaoDiaria },
};
</script>

<style>
</style> 
